export default __webpack_public_path__ + "static/media/home.567b81c0.gif";